import React from 'react';
import BrakeInString from './BrakesInString';
import CustomLink from './CustomLink'
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import NoPhoto from '../img/no-photo.png'

const NewsItem = (props) => {
  const image = props.image ? props.image : '';
  const imageAlt = props.imageAlt ? props.imageAlt : '';
  const date = props.date ? props.date : '';
  const title = props.title ? props.title : '';
  const text = props.text ? props.text : '';
  const linkText = props.linkText ? props.linkText : '';
  const linkUrl = props.linkUrl ? props.linkUrl : '';
  const linkType = props.linkType ? props.linkType : '';
  const externalImageUrl = props.externalImageUrl ? props.externalImageUrl : null;

  return (
    <div className="news-item">
      <div className="news-item__header">
        <div className="news-item__image">
          <CustomLink
              linkType={linkType}
              linkURL={(linkType !== 'external') ? '/' + linkUrl : linkUrl}
          >
            <img src={externalImageUrl || image || NoPhoto} alt={imageAlt}/>
          </CustomLink>
        </div>
        <div className="news-item__header-text">
          <div className="news-item__date">
            {date}
          </div>
          <div className="news-item__title">
            <h3>
              <CustomLink
                  linkType={linkType}
                  linkURL={(linkType !== 'external') ? '/' + linkUrl : linkUrl}
              >
                <BrakeInString text={title}></BrakeInString>
              </CustomLink>
            </h3>
          </div>
        </div>
      </div>
      <div className="news-item__inner">
        <div className="news-item__inner-text">
          <ReactMarkdown skipHtml remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{text}</ReactMarkdown>
        </div>
        <div className="news-item__inner-link">
          <CustomLink
            linkType={linkType}
            linkURL={(linkType !== 'external') ? '/' + linkUrl : linkUrl}
          >
            {linkText}
          </CustomLink>
        </div>
      </div>
    </div>
  );
};

export default NewsItem;